import React, {useEffect} from 'react';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';

const setIfUndefined = (obj, property, initialValue, prevModified) => {
  let isDefaultReq = !_.has(obj, property);
  if (isDefaultReq) {
    _.set(obj, property, initialValue);
  }
  return prevModified || isDefaultReq;
};

export const ApplicationInitDefaultSetupListener = (props) => {
  const {
    defaults,
    sessionOnly,
    entityDataPath,
    entityType,
    data,
    saveEntityData,
    saveEntitySessionData,
  } = props;

  // Should execute onMount only
  useEffect(() => {
    const cloneData = JSON.parse(JSON.stringify(data || {}));
    let isModified = false;
    _.map(defaults, (defaultObj) => {
      isModified = setIfUndefined(
        cloneData,
        defaultObj.path,
        defaultObj.value,
        isModified
      );
    });
    if (isModified) {
      if (sessionOnly) {
        saveEntitySessionData(entityDataPath, cloneData);
      } else {
        saveEntityData(entityDataPath, entityType, cloneData);
      }
    }
  }, []);
  return <></>;
};

export default connectDynamic(ApplicationInitDefaultSetupListener);
